import React from "react";
import styles from "./style.module.scss";
import { isEqual } from "lodash";
import { useSelector } from "react-redux";
import { BsArrowUp } from "react-icons/bs";
import { BsSun } from "react-icons/bs";
import { TbRoad } from "react-icons/tb";
import { RiWaterPercentLine } from "react-icons/ri";
import { LuGauge } from "react-icons/lu";
import weatherBackground from "../../../assets/images/clouds.jpg";
import { IconType } from "react-icons";
import { Tooltip } from "react-tooltip";
import { RootState } from "../../../state";

type Cards = Record<
  string,
  {
    value: number | null;
    unit: string;
    icon: IconType;
    rotation?: number | null;
  }
>;

function Weather() {
  const sessionData = useSelector(
    (state: RootState) => state.aks.v2.weather?.sessionData,
    isEqual,
  ) as Record<string, { [key: string]: number | null }>;

  let lastKey: number | undefined;
  if (sessionData) {
    const keys = Object.keys(sessionData);
    const keysNumbers = keys.map(Number);
    const keysList = keysNumbers.sort(function (a, b) {
      return a - b;
    });
    lastKey = keysList[keysList.length - 1];
  }

  const getSessionDataValue = (key: string): number | null => {
    return lastKey !== undefined
      ? sessionData?.[`${lastKey}`]?.[key] ?? null
      : null;
  };

  const dayTime = getSessionDataValue("dayTime");

  const cards: Cards = {
    ambientTemperature: {
      value: getSessionDataValue("ambientTemperature"),
      unit: "°C",
      icon: BsSun,
    },
    trackTemperature: {
      value: getSessionDataValue("trackTemperature"),
      unit: "°C",
      icon: TbRoad,
    },
    humidity: {
      value: getSessionDataValue("humidity"),
      unit: "%",
      icon: RiWaterPercentLine,
    },
    windSpeed: {
      value: getSessionDataValue("windSpeed"),
      unit: "kph",
      icon: BsArrowUp,
      rotation: getSessionDataValue("windDirection"),
    },
    pressure: {
      value: getSessionDataValue("pressure"),
      unit: "mbar",
      icon: LuGauge,
    },
  };

  const nCards = Object.keys(cards).length;

  return (
    <div
      className={styles.weather}
      style={{ backgroundImage: `url(${weatherBackground})` }}
    >
      <Tooltip id="weatherTooltip" />
      <div className={styles.cardContainer}>
        {Object.keys(cards).map((key) => {
          const card = cards[key];
          const Icon = card.icon;
          return (
            <div
              className={styles.card}
              style={{ width: `${100 / nCards}%` }}
              key={key}
              data-tooltip-id="weatherTooltip"
              data-tooltip-content={key}
              data-tooltip-place="top"
            >
              <div>
                <Icon
                  size="40px"
                  className={styles[key]}
                  style={{ transform: `rotate(${card.rotation ?? 0}deg)` }}
                />
              </div>
              <div>
                {card.value !== null
                  ? `${card.value.toFixed(1)} ${card.unit}`
                  : null}
              </div>
            </div>
          );
        })}
      </div>
      <div className={styles.timeContainer}>
        {dayTime ? new Date(dayTime).toLocaleTimeString("default") : null}
      </div>
    </div>
  );
}
export default Weather;
